import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

export interface ResponsivePaddingProps {
  desktop?: string;
  mobile?: string;
  children?: React.ReactNode;
}

export const StyledPadding = styled.div`
  @media (min-width: 1000px) {
    padding: ${(props: ResponsivePaddingProps) => props.desktop ?? '0 35% 0 0'};
  }

  @media (max-width: 1000px) {
    padding: ${(props: ResponsivePaddingProps) => props.mobile ?? '0'};
  }
`;

export const ResponsivePadding: FunctionComponent<
  ResponsivePaddingProps
> = props => {
  return <StyledPadding {...props} />;
};
